module.exports = __webpack_public_path__ + "static/media/vf_mshirts_core.c8eba870.svg";